export const ENTITY_NAME = 'ENTITY_'
export const GET_LIST_ENTITY = 'GET_LIST_ENTITY'

export const SET_PAGINATION  =  'SET_PAGINATION'
export const SET_PAGINATION_PER_PAGE = 'SET_PAGINATION_PER_PAGE'
export const SET_PAGINATION_PAGE = 'SET_PAGINATION_PAGE'
export const SET_SEARCH_ENTITY = 'SET_SEARCH_ENTITY'
export const SET_SORT_ENTITY = 'SET_SORT_ENTITY'
